// extracted by mini-css-extract-plugin
export default {"pageWrap":"Ec-z","fullWidth":"Fc-z","heading":"Gc-z","fullBleed":"Hc-z","hidden":"Ic-z"};